// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const filterListApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    getCategoryList: builder.query({
      query: (query) => {
        return {
          url: `category?is_paginate=false`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      transformResponse: (response) => {
        const list = response.data
          .filter((item) => item.name && item.name.trim() !== "")
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));
        return [{ value: "all", label: "All Category" }, ...list];
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCategoryListQuery } = filterListApi;
